import { createFileRoute, redirect } from '@tanstack/react-router';
import { useSessionStore } from '@/entities/session/model/sessionStore';
import { ChangePasswordPage } from '@/pages/auth/ui/ChangePasswordPage';
import { tokenManager } from '@/shared/lib/storage';
import { getSessionStorage } from '@/shared/lib/storage/session-storage';

/**
 * パスワード変更ルート定義
 *
 * App層の責務:
 * - URLパス `/change-password` を ChangePasswordPage にマッピング
 * - 未認証の場合は `/login` にリダイレクト
 * - ブラウザ再起動後（セッション外）の場合はログインからやり直し
 * - 初回ログインでない場合は `/home` にリダイレクト
 */
export const Route = createFileRoute('/change-password')({
  beforeLoad: () => {
    // 未認証の場合はログインページへ
    if (!tokenManager.isAuthenticated()) {
      throw redirect({ to: '/login' });
    }

    // ブラウザ再起動後（sessionStorage が消えた状態）ではトークンをクリアしてログインからやり直させる
    // beforeLoad 内で queryClient.clear() を含む logout() を呼ぶと、
    // AuthProvider の /me クエリがエラーになり /404 に遷移するため、トークンクリアのみ行う
    if (!getSessionStorage('login-session-active')) {
      tokenManager.clearTokens();
      throw redirect({ to: '/login' });
    }

    // パスワード変更済みの場合はホームへ
    const user = useSessionStore.getState().user;
    if (user?.isFirstLoginCompleted) {
      throw redirect({ to: '/home' });
    }
  },
  component: ChangePasswordPage,
});
